import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ArticleRefreshResponseDto } from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';

interface ApiErrorResponse {
  detail?: string;
  message?: string;
}

export const useRefreshArticle = () => {
  const { t } = useTranslation(['knowledge_base']);

  const mutation = useMutation<ArticleRefreshResponseDto, AxiosError<ApiErrorResponse>, number>({
    mutationKey: [QueryKey.knowledgeBase.articles.refresh],
    onSuccess: () => {
      toast.success(t('knowledge_base:article.toast.refresh_started'));
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        t('knowledge_base:article.toast.refresh_failed');
      toast.error(errorMessage);
    },
  });

  const refreshArticle = (articleId: number) => {
    mutation.mutate(articleId);
  };

  return {
    refreshArticle,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
